import { render, staticRenderFns } from "./CryptoWallets.vue?vue&type=template&id=90c6ef2a&scoped=true"
import script from "./CryptoWallets.vue?vue&type=script&lang=js"
export * from "./CryptoWallets.vue?vue&type=script&lang=js"
import style0 from "./CryptoWallets.vue?vue&type=style&index=0&id=90c6ef2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c6ef2a",
  null
  
)

export default component.exports